import React, { useEffect, useState } from "react";
import OTPInput from "otp-input-react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { useComponent } from "../common/Modal";
import {
  otpVerification,
  resendOtpAPI,
  userSignup,
} from "../../services/apiServices";
import { useTranslation } from "react-i18next";

const OtpVerification = ({ userData }) => {
  const { setCurrentComponent, setUserData, onClose } = useComponent();
  const navigate = useNavigate();
  const [Otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const { t } = useTranslation();
  const {
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      if (Otp.length !== 5) {
        setError("otp", {
          type: "manual",
          message: t("otp_invalid"),
        });
        return;
      }
      setLoading(true);
      const payload = {
        email: userData?.email?.toLowerCase(),
        otp: Otp,
      };
      const response = await otpVerification(payload);
      if (response?.data?.statusCode == 200) {
        toast.success(response?.data?.message || t("otp_success"), {
          position: "top-right",
          autoClose: 3000,
        });
        setCurrentComponent("signIn");
        reset();
      } else {
        toast.error(
          response?.data?.message || t("otp_failed"),
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
      }
    } catch (error) {
      console.warn("error coming in otp verification:", error);
      setCurrentComponent("");
    } finally {
      setLoading(false);
    }
  };
  const resendOtp = async () => {
    try {
      setLoading(true);
      const payload = {
        email: userData?.email,
      };
      const response = await resendOtpAPI(payload);
      if (response?.data?.statusCode == 200) {
        toast.success(
          response?.data?.message || t("otp_resend_success"),
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
      } else {
        toast.error(
          response?.data?.message || t("otp_resend_failed"),
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
      }
    } catch (error) {
      setCurrentComponent("");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setEmail(email);
  }, [userData]);
  return (
    <div>
      <h2 className="text-2xl text-primary-text font-semibold text-center">
        {t("otp_title")}
      </h2>

      <h5 className="text-center mt-2 text-lg text-[#5D5D5D] font-medium">
        {t("otp_subtitle")}
      </h5>

      <form onSubmit={handleSubmit(onSubmit)}>
        <OTPInput
          value={Otp}
          onChange={(value) => {
            setOtp(value);
            if (value.length === 5) {
              clearErrors("otp");
            }
          }}
          autoFocus
          OTPLength={5}
          otpType="number"
          disabled={false}
          inputClassName="bg-[#F0F0F0] w-full focus:outline-none focus:border focus:border-[#ACB1C4] rounded-[10px]"
          inputStyles={{
            width: "50px",
            height: "50px",
            textAlign: "center",
          }}
          style={{
            justifyContent: "center",
            width: "100%",
            margin: "0 auto",
            marginTop: "24px",
          }}
        />

        {errors.otp && (
          <p className="text-red-600 text-sm text-center mt-2">
            {errors.otp.message}
          </p>
        )}

        <p className="text-center mt-8 text-base font-medium">
          {t("otp_not_received")} {" "}
          <span
            className="text-red-600 cursor-pointer"
            onClick={() => resendOtp()}
          >
            {t("otp_resend")}
          </span>
        </p>

        <div className="mt-4">
          <button
            type="submit"
            className="w-full text-base bg-red-600 text-white p-3 rounded-[121px] font-semibold"
          >
            {loading ? <ClipLoader size={20} color="#fff" /> : t("otp_continue")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default OtpVerification;
